import cbSkinMainLayout from './skins/cbSkin/layouts/MainLayout';
import cbSkinConfigureStore from './skins/cbSkin/store';
import cbOSESkinMainLayout from './skins/CbOSESkin/layouts/MainLayout';
import cbOSESkinConfigureStore from './skins/CbOSESkin/store'




let Components = {};

Components['cbSkin_MainLayout'] = cbSkinMainLayout
Components['cbSkin_ConfigureStore'] = cbSkinConfigureStore
Components['CbOSESkin_MainLayout'] = cbOSESkinMainLayout
Components['CbOSESkin_ConfigureStore'] = cbOSESkinConfigureStore

export default Components
